let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a6uKK")).then(() => parcelRequire('ic1wA'));